<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <editor
          ref="note_editor"
          v-model="form.note"
          :area="travelGroup.image_path"
        ></editor>

        <b-field>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            :style="{ width: '100%' }"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'

export default {
  name: 'NoteForm',
  components: { Editor },

  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,

      group_code: this.travelGroup.code,
      form: this.extractFormValues(this.travelGroup),

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      note: {}
    }
  },
  watch: {
    travelGroup(newGroup) {
      this.group_code = newGroup.code
      this.form = this.extractFormValues(newGroup)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        note: data.note || ''
      }
    },
    async onSend() {
      this.form.note = this.$refs.note_editor.getData()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${TRAVEL_GROUPS_API}/${this.group_code}/note`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)
        this.$emit('updated', res.data.data)
        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    }
  }
}
</script>
